import Vue from 'vue';
import { DataService } from '../../data.service';

const chartID = 'getCountyOverallChangePercent';
/**
 * Tab 1: General: Percent Area That Changed
 * getCountyOverallChangePercent
 */
export class Tab1Chart1 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0]);
            }
        })
        this.renderChart();
    }

    updateChartData(response) {
        this.chart.chartOptions.series[0].data[0].y = +response.value;
        this.chart.chartOptions.series[0].data[1].y = 100.0 - +response.value;
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Percent Area That Changed',
                        loading: true
                    },
                    animationDuration: 1000,
                    updateArgs: [true, true, { duration: 1000 }],
                    chartOptions: {
                        chart: {
                            type: 'pie'
                        },
                        tooltip: {
                            enabled: false
                        },
                        colors: ['#336699', '#eeeeee'],
                        series: [
                            {
                                name: 'Percent Change',
                                data: [
                                    {
                                        name: 'Change',
                                        sliced: true,
                                        selected: true,
                                        y: 71.59
                                    }, {
                                        name: 'No Change',
                                        y: 29.41
                                    }
                                ]
                            }
                        ]
                    }
                }
            },
            computed: {
                chartVal: function () {
                    return this.chartOptions.series[0].data[0].y.toFixed(2);
                }
            }
        });
        //end vue component

    }
}
